import { useState, useContext, useEffect } from "react"
import { AuthContext } from "../context/AuthContext"
import { useNavigate } from "react-router-dom"

function Profile(){

const { user, logout } = useContext(AuthContext)
const navigate = useNavigate()

const [active,setActive] = useState("dashboard")
const [orders,setOrders] = useState([])
const [address,setAddress] = useState(null)

// 🔒 Redirect
useEffect(()=>{
if(!user){
navigate("/account")
}
},[user,navigate])

// 🔥 Orders (same as Orders.jsx)
useEffect(()=>{
const saved = localStorage.getItem("orders_history")
if(saved){
try{
setOrders(JSON.parse(saved).reverse())
}catch(e){
setOrders([])
}
}
},[])

// 🔥 ✅ ADDRESS FIX (same as Checkout.jsx)
useEffect(()=>{
const saved = localStorage.getItem("address_data") // ✅ सही key
if(saved){
try{
setAddress(JSON.parse(saved))
}catch(e){
setAddress(null)
}
}
},[])

return(

<div className="accountDashboard">

<div className="accountSidebar">
<h3>My Account</h3>
<ul>
<li onClick={()=>setActive("dashboard")}>Dashboard</li>
<li onClick={()=>setActive("profile")}>Profile Info</li>
<li onClick={()=>setActive("orders")}>My Orders</li>
<li onClick={()=>setActive("address")}>Addresses</li>
<li onClick={logout}>Logout</li>
</ul>
</div>

<div className="accountContent">

{/* DASHBOARD */}
{active==="dashboard" && (

<div>
<h2>Welcome {user?.name}</h2>
<p>Manage your profile, orders and addresses from here.</p>
</div>
)}

{/* PROFILE */}
{active==="profile" && (

<div>
<h2>Profile Information</h2>
<p><b>Name:</b> {user?.name || "N/A"}</p>
<p><b>Email:</b> {user?.email || "N/A"}</p>
</div>
)}

{/* 🔥 ORDERS (SAME FORMAT AS Orders.jsx) */}
{active==="orders" && (

<div className="orders-container">

<h2 className="page-title">My Orders</h2>

{orders.length === 0 ? (

<div className="no-orders">
<p>No orders found.</p>
<button onClick={()=>navigate("/")}>Start Shopping</button>
</div>
) : (
<div className="orders-list">

{orders.map(order => (

<div key={order.id} className="order-card">

<div className="order-header">

<div className="header-column">
<p className="label">ORDER PLACED</p>
<p className="val">{order.date || "N/A"}</p>
</div>

<div className="header-column">
<p className="label">TOTAL</p>
<p className="val">₹{order.total}</p>
</div>

<div className="header-column">
<p className="label">ORDER ID</p>
<p className="val">#{order.id?.slice(-8).toUpperCase()}</p>
</div>

<div className="header-column">
<span className={`status-badge ${order.status?.toLowerCase() || 'processing'}`}>
{order.status || "Processing"}
</span>
</div>

</div>

<div className="order-items">

{order.line_items && order.line_items.map((item,index)=>(

<div key={index} className="order-item-row">

<img
src={item.image || (item.images && item.images[0]?.src) || "https://via.placeholder.com/50"}
alt={item.name}
className="order-item-img"
/>

<div className="item-info">
<p>{item.name}</p>
<span>Qty: {item.quantity || item.qty}</span>
</div>

</div>
))}

{(!order.line_items || order.line_items.length === 0) && (

<p className="no-items-text">Order details processed successfully.</p>
)}

</div>

</div>
))}

</div>
)}

</div>
)}

{/* 🔥 ADDRESS FIXED */}
{active==="address" && (

<div>

<h2>My Address</h2>

{address ? (

<div className="addressCard">

<p><b>{address.name}</b></p>
<p>{address.phone}</p>
<p>{address.email}</p>
<p>{address.fullAddress}</p>

</div>

):(

<p>No address saved</p>

)}

</div>
)}

</div>

</div>

)

}

export default Profile
